import { deleteApp } from "firebase/app";

import "../styles/rainbox.css";

function AltIFrame() {
    return <iframe width={"100%"} height={"100vh"} style={{"width": "100%", "height": "100vh", "border": "none"}} src={"https://valentinahrend.github.io"}></iframe>
}
export default AltIFrame;